@if (loading.process.pending$ | async) {
  <mat-progress-bar mode="query">
    <mat-progress-bar></mat-progress-bar>
  </mat-progress-bar>
}
